/*
 * Product media lightbox slider.
 *
 * Defines <product-modal> with Swiper behaviour instead of Dawn's scroll-stack. Loaded in place
 * of product-modal.js on the product page; both guard on customElements.get('product-modal'),
 * so whichever a template loads wins and the other no-ops.
 *
 * Scoped entirely to the modal element — ModalDialog moves it to document.body, so nothing here
 * may rely on the section wrapper still being an ancestor.
 */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      get sliderElement() {
        return this.querySelector('.pi-modal__swiper');
      }

      get slides() {
        return Array.from(this.querySelectorAll('.pi-modal__slide'));
      }

      initSlider() {
        const element = this.sliderElement;
        if (!element || typeof Swiper === 'undefined') return null;

        // theme-vendors.js may already have initialised it; Swiper stamps the instance on the node
        if (!element.swiper) {
          let options = {};
          try {
            options = JSON.parse(element.dataset.sliderOptions || '{}');
          } catch (error) {
            console.warn('Product media modal: slider options parse error', error);
          }
          new Swiper(element, options);
        }

        // product-info.js replaces .product-media-modal__content innerHTML on every variant
        // change, which throws away this element and its Swiper. Track the binding on the
        // element itself so the replacement gets its own listener instead of being skipped.
        if (element.swiper && element.dataset.piModalBound !== 'true') {
          element.dataset.piModalBound = 'true';
          element.swiper.on('slideChange', () => {
            window.pauseAllMedia();
            this.loadSlideMedia(this.slides[element.swiper.activeIndex]);
          });
        }

        return element.swiper;
      }

      loadSlideMedia(slide) {
        if (!slide) return;
        const deferred = slide.querySelector('.deferred-media');
        const template = deferred && deferred.querySelector('template');
        // only auto-load YouTube, matching Dawn — other media wait for the poster click
        if (deferred && template && template.content.querySelector('.js-youtube')) {
          deferred.loadContent();
        }
      }

      show(opener) {
        super.show(opener);

        const slides = this.slides;
        const mediaId = opener && opener.getAttribute('data-media-id');
        let index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
        if (index < 0) index = 0;

        const swiper = this.initSlider();

        if (swiper) {
          // the modal was visibility:hidden until super.show(), so re-measure before jumping
          swiper.update();
          swiper.slideTo(index, 0);
        } else {
          slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        }

        this.loadSlideMedia(slides[index]);
      }

      hide() {
        const swiper = this.sliderElement && this.sliderElement.swiper;
        if (swiper && swiper.zoom) swiper.zoom.out();
        super.hide();
      }
    }
  );
}
